import { create } from "zustand";

export type StoryDetails = {
  description: string;
  notes: string;
  storyTitle: string;
};

type WizardStoryStore = {
  storyDetails: StoryDetails;
  setStoryDetails: (next: StoryDetails) => void;
  resetStoryDetails: () => void;
};

export const useWizardStore = create<WizardStoryStore>((set) => ({
  storyDetails: { description: "", notes: "", storyTitle: "" },
  setStoryDetails: (storyDetails) => set({ storyDetails }),
  resetStoryDetails: () => set({ storyDetails: { description: "", notes: "", storyTitle: "" } }),
}));
